import React from 'react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { defaultNS } from 'next-i18next.config';

import isCrawlers from 'lib/utils/isCrawlers';
import generateHreflang from 'lib/utils/generateHreflang';
import { serverFetch } from 'lib/utils/serverFetch';
import { mapNamedLocaleToLocale } from 'lib/data/localesMap';
import PATHS from 'lib/navigation/paths';
import { API } from 'lib/config/axios';
import useErrorsHandler from 'views/rebranded-module/common/hooks/useErrorsHandler';

import { LocationsViewV2 } from 'views/rebranded-module/location-module/LocationsViewV2';
import { HydrationWrapper } from 'views/common/components';
import { checkIfUrlHasCorrectSegmentsTranslations } from 'lib/utils/checkIfUrlHasCorrectSegmentsTranslations';
import { cmsServerFetch } from 'lib/utils/cmsServerFetch';
import { locationPageCMSQuery } from 'views/rebranded-module/location-module/LocationsViewV2/utils/locationPageCMSQuery';
import { ContentContext } from 'views/rebranded-module/common/context/useContent';

const Locations = (props) => {
  const {
    serverData, renderErrorPage, ssrRender, cmsData,
  } = props;

  const handleErrorResponse = useErrorsHandler();
  if (renderErrorPage) {
    handleErrorResponse({}, false);
  }

  return (
    <ContentContext.Provider value={cmsData}>
      <HydrationWrapper>
        <LocationsViewV2 serverData={serverData} ssrRender={ssrRender} />
      </HydrationWrapper>
    </ContentContext.Provider>
  );
};
export async function getServerSideProps(ctx) {
  const ssrRender = isCrawlers(ctx.req.headers['user-agent']);
  let serverData = null;
  let renderErrorPage = false;
  let cmsData = null;
  const hreflangData = ctx.query.club_locations_segment
    ? generateHreflang(PATHS.clubLocations().url, ctx.locale)
    : generateHreflang(PATHS.locations().url, ctx.locale);

  const params = { ...ctx.query };
  let layoutData = null;

  try {
    const [layoutRes, pageRes, locationsPageCMSResponse] = await Promise.all([
      serverFetch(ctx, API.layout, params),
      serverFetch(ctx, API.locations, {
        only_club_ones: ctx.query.club_locations_segment !== undefined,
      }),
      cmsServerFetch(ctx, locationPageCMSQuery),
    ]);
    if (layoutRes.success && pageRes.success) {
      layoutData = layoutRes.data;
      serverData = pageRes.data;
    } else {
      throw new Error('Failed to fetch server data');
    }

    if (locationsPageCMSResponse.success) {
      cmsData = locationsPageCMSResponse.cmsData;
    } else {
      throw new Error('Failed to fetch cms server data');
    }
  } catch (e) {
    ctx.res.statusCode = 503;
    renderErrorPage = true;
    throw new Error(e);
  }
  const isCorrectSegemntTranslation = checkIfUrlHasCorrectSegmentsTranslations(
    ctx,
    hreflangData.canonical,
  );
  if (isCorrectSegemntTranslation.shouldRedirect) {
    return {
      redirect: {
        destination: isCorrectSegemntTranslation.redirectURL,
        permanent: true,
      },
    };
  }
  return {
    props: {
      ...(await serverSideTranslations(mapNamedLocaleToLocale[ctx.locale], [
        ...defaultNS,
        'locationsV2_page',
        'common_floating_location_info',
        'fe_er_common_main_widget',
        'common_main_widget_v2',
        'common_radio_filter_v2',
      ])),
      serverData,
      renderErrorPage,
      ssrRender,
      hreflangData,
      cmsData,
      layoutData,
      rebrandingPage: true,
      options: {
        showAiChat: true,
      },
    },
  };
}

export default Locations;
